import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./landing-page/landing-page.component').then(a => a.LandingPageComponent)
    },
    {
        path: 'awb/:awb_number',
        pathMatch: 'full',
        loadComponent: () => import('./landing-page/landing-page.component').then(a => a.LandingPageComponent)
    },
    {
        path: 'help-center/:order_id/:request_type',
        pathMatch: 'full',
        loadChildren: () => import('./help-center/help-center.module').then(a => a.HelpCenterModule)
    },
    {
        path: 'track',
        pathMatch: 'full',
        loadChildren: () => import('./order-information/order-information.module').then(a => a.OrderInformationModule)
    },
    {
        path: 'track/:order_id/:request_type/:secret_key',
        pathMatch: 'full',
        loadChildren: () => import('./order-information/order-information.module').then(a => a.OrderInformationModule)
    },
    {
        path: 'track/:order_id/:request_type',
        pathMatch: 'full',
        loadChildren: () => import('./order-information/order-information.module').then(a => a.OrderInformationModule)
    },
    {
        path: 'location/:order_id/:request_type/:secret_key',
        pathMatch: 'full',
        loadChildren: () => import('./share-location/share-location.module').then(a => a.ShareLocationModule)
    },
    {
        path: 'location/:order_id/:request_type',
        pathMatch: 'full',
        loadChildren: () => import('./share-location/share-location.module').then(a => a.ShareLocationModule)
    },
    {
        path: 'payment/:order_id/:request_type/:secret_key',
        pathMatch: 'full',
        loadChildren: () => import('./cod-payment/cod-payment.module').then(a => a.CodPaymentModule)
    },
    {
        path: 'payment/:order_id/:request_type',
        pathMatch: 'full',
        loadChildren: () => import('./cod-payment/cod-payment.module').then(a => a.CodPaymentModule)
    },
    { 
        path: '**', 
        pathMatch: 'full' ,
        redirectTo: '', 
    }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', useHash: true })],
    exports: [RouterModule]
})

export class AppRoutingModule { }
